import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Formative' },
    { value: 2, label: 'Summative' },
    { value: 3, label: 'Both' },
  ],
});
